export default "__VITE_ASSET__W5MNPbX0__"